export default class Link {

  constructor(label, title, target, onClick) {
    this.label = label;
    this.title = title;
    this.target = target;
    this.iconName = '';
    this.hasSeparator = false;
    this.hasAlert = false;
    this.hasMenuBorder = true;
    this.onClick = onClick || this.defaultOnClick;
    this.altStates = [];
    this.fromStates = [];
  }

  defaultOnClick() {
    return false;
  }

  setNoMenuBorder() {
    this.hasMenuBorder = false;
  }

  setAlertIcon(iconName) {
    this.iconName = iconName;
    this.hasAlert = true;
  }

  setSeparator() {
    this.hasSeparator = true;
  }

  setAltStates(altStates) {
    this.altStates = altStates;
  }

  setFromStates(fromStates) {
    this.fromStates = fromStates;
  }
}



// WEBPACK FOOTER //
// ./client/app/components/mainMenu/link.js